import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import TestimonialsComp from "../../components/Testimonials/TestimonialsComp";

const Testimonials = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='Testimonials' />

                {/* TestimonialsLayer */}
                <TestimonialsComp />
            </MasterLayout>
        </>
    );
};

export default Testimonials;
